// === GENERATED FILE ===
// DO NOT EDIT DIRECTLY, EDIT sh-search.lit.scss INSTEAD!
import { css } from 'lit-element';
export default css`:root,
[sh-scale=s] {
  /* 
   * @cssprop [--sh-search-icon-top=0.5rem] - top margin of search icon
   */
  --sh-search-icon-top: 0.5rem;
  /* 
   * @cssprop [--sh-search-icon-left=0.5rem] - left margin of search icon
   */
  --sh-search-icon-left: 0.5rem;
  /* 
   * @cssprop [--sh-search-input-height=2.5rem] - height of search input
   */
  --sh-search-input-height: 2.5rem;
  /* 
   * @cssprop [--sh-search-value-line-height=0.5rem] - line-height of value
   */
  --sh-search-value-line-height: 0.5rem;
  /* 
   * @cssprop [--sh-search-input-padding=0.5rem 2.5rem] - padding of input
   */
  --sh-search-input-padding: 0.5rem 2.5rem;
  /* 
   * @cssprop [--sh-search-border-radius=0.125rem 0.125rem 0rem 0rem] - border-radius of input
   */
  --sh-search-border-radius: 0.125rem 0.125rem 0rem 0rem;
  /* 
   * @cssprop [--sh-search-border-bottom-thickness=0.0625rem] - border-bottom of input
   */
  --sh-search-border-bottom-thickness: 0.0625rem;
  /* 
   * @cssprop [--sh-search-list-item-height=2.5rem] - list-item-height
   */
  --sh-search-list-item-height: 2.5rem;
  /* 
   * @cssprop [--sh-search-single-line-list-item-padding=0.5rem] - list-item-padding
   */
  --sh-search-single-line-list-item-padding: 0.5rem;
  /* 
   * @cssprop [--sh-search-list-item-line-height=1.5rem] - line-height of list item
   */
  --sh-search-list-item-line-height: 1.5rem;
  /* 
   * @cssprop [--sh-search-close-icon-right=0.5rem] - distance between right of close icon and right of search input
   */
  --sh-search-close-icon-right: 0.5rem;
  /* 
   * @cssprop [--sh-search-multi-line-list-item-padding=0.25rem 0.5rem] - multi-line list-item padding
   */
  --sh-search-multi-line-list-item-padding: 0.25rem 0.5rem;
  /* 
   * @cssprop [--sh-search-multi-line-list-item-height=2.5rem] - multi-line list-item height
   */
  --sh-search-multi-line-list-item-height: 2.5rem;
  /* 
   * @cssprop [--sh-search-multi-line-single-item-height=1rem] - multi-line single-item height
   */
  --sh-search-multi-line-single-item-height: 1rem;
  /* 
   * @cssprop [--sh-search-empty-wrapper-padding=1rem 0.5rem] - padding of empty wrapper
   */
  --sh-search-empty-wrapper-padding: 1rem 0.5rem;
  /* 
   * @cssprop [--sh-search-list-view-max-height=13.75rem] - max-height of list-view
   */
  --sh-search-list-view-max-height: 13.75rem;
  /* 
   * @cssprop [--sh-search-empty-slot-item-gap=1rem] - the gap between the items in empty slot
   */
  --sh-search-empty-slot-item-gap: 1rem;
}

:host {
  width: 100%;
  display: block;
  height: var(--sh-search-input-height);
  position: relative;
}

input,
:host([readonly]) input:focus {
  line-height: var(--sh-search-value-line-height) !important;
  padding: var(--sh-search-input-padding);
  border-radius: var(--sh-search-border-radius);
  background: rgba(var(--ui-1), var(--opacity-7));
  height: var(--sh-search-input-height);
  color: var(--text-primary);
  font: var(--body-1);
  border: none;
  outline: none;
  box-sizing: border-box;
  width: 100%;
  text-overflow: ellipsis;
  transition: var(--transition-time) all ease-in-out;
  border-bottom: var(--sh-search-border-bottom-thickness) solid transparent;
  border-color: rgba(var(--ui-1), var(--opacity-4));
}

input::-ms-clear {
  display: none;
}

:host([disabled]) input {
  color: var(--text-disabled);
  background: rgba(var(--ui-1), var(--opacity-7));
}

sh-icon {
  position: absolute;
  top: var(--sh-search-icon-top);
  left: var(--sh-search-icon-left);
  cursor: pointer;
}

#showSearch {
  max-height: var(--sh-search-list-view-max-height) !important;
}

.empty-wrapper {
  display: flex;
  flex-direction: column;
  gap: var(--sh-search-empty-slot-item-gap);
}

#showSearch,
.empty-wrapper {
  overflow: auto;
  background: var(--base-4);
  z-index: 1;
  box-shadow: var(--shadow-overlay);
  box-sizing: border-box;
}

.name {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

#showSearch .itemList {
  height: var(--sh-search-list-item-height);
  padding: var(--sh-search-single-line-list-item-padding);
  font: var(--body-1);
  color: var(--text-primary);
  line-height: var(--sh-search-list-item-line-height);
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  box-sizing: border-box;
}

.closeIcon {
  position: absolute;
  left: auto;
  right: var(--sh-search-close-icon-right);
  cursor: pointer;
  color: rgba(var(--ui-1), var(--opacity-4));
  background: transparent !important;
}

:host([disabled]) input::-moz-placeholder {
  color: var(--text-disabled);
  opacity: unset;
}

:host([disabled]) input::-webkit-input-placeholder,
:host([disabled]) input::placeholder {
  color: var(--text-disabled);
}

input::-webkit-input-placeholder,
input::placeholder,
input::-moz-placeholder {
  font: var(--body-1);
  color: var(--text-secondary);
}

.searchText {
  white-space: pre;
  color: var(--text-primary);
  font: var(--title-1);
}

/* hover */
input:hover {
  background: rgba(var(--ui-1), var(--opacity-6));
}

input:focus {
  border-color: rgba(var(--ui-1), var(--opacity-2));
}

:host(:not(.no-hovermq)) #showSearch .itemList:hover,
#showSearch .itemList.hover {
  cursor: pointer;
  background: rgba(var(--ui-1), var(--opacity-7));
}

:host(:not(.no-hovermq)) .closeIcon:hover,
.closeIcon.hover {
  color: rgba(var(--ui-1), var(--opacity-3));
}

:host(:not(.no-hovermq)) ::-webkit-input-placeholder:hover {
  font: var(--body-1);
  color: var(--text-secondary);
}

.itemList.active {
  background: rgba(var(--ui-1), var(--opacity-7));
}

/*multiline suggestions */
:host([multiline]) #showSearch .itemList {
  padding: var(--sh-search-multi-line-list-item-padding);
  height: var(--sh-search-multi-line-list-item-height);
}

:host([multiline]) #showSearch .itemList div {
  height: var(--sh-search-multi-line-single-item-height);
  line-height: var(--sh-search-multi-line-single-item-height);
}

:host([multiline]) #showSearch .firstItem {
  font: var(--body-1);
  color: var(--text-primary);
}

:host([multiline]) #showSearch .secondItem {
  font: var(--body-2);
  color: var(--text-secondary);
}

.secondItem .searchText {
  font: var(--title-2);
}

.firstItem,
.secondItem {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.empty-wrapper {
  padding: var(--sh-search-empty-wrapper-padding);
}

input::-moz-placeholder {
  font: var(--body-1);
  color: var(--text-secondary);
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  word-break: break-all;
}

input::placeholder {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  word-break: break-all;
  font: var(--body-1);
  color: var(--text-secondary);
}

:host([value=""]) #showSearch,
:host([value=""]) .empty-wrapper {
  display: none;
}`;